import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import './header.scss';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Div from '../Div';

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ''
        } cs-sticky_header ${isSticky ? 'cs-sticky_header_active' : ''}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Link className="cs-site_branding" to="/">
                  <img src="/images/newlogo.png" alt="Logo" />
                </Link>
              </Div>
              <Div className="cs-main_header_center">
                <Div className="cs-nav cs-primary_font cs-medium">
                 
                 
                 
                 <ul
  className="cs-nav_list"
  style={{ display: `${mobileToggle ? 'block' : 'none'}` }}
>
  {/* Home as standalone button */}
  <li>
    <NavLink to="/" onClick={() => setMobileToggle(false)}>
      Home
    </NavLink>
  </li>
  {/* About */}
  <li>
    <NavLink to="about" onClick={() => setMobileToggle(false)}>
      About
    </NavLink>
  </li>
  {/* Services with dropdown */}
  <li className="menu-item-has-children">
    <NavLink to="service" onClick={() => setMobileToggle(false)}>
      Services
    </NavLink>
    <ul className="dropdown-menu">
      <li>
        <Link to="service" onClick={() => setMobileToggle(false)}>
          Services
        </Link>
      </li>
      <li>
        <Link to="/service/service-details" onClick={() => setMobileToggle(false)}>
          Service Details
        </Link>
      </li>
    </ul>
  </li>
  {/* Creative Portfolio as standalone button */}
  <li>
    <NavLink to="/portfolio" onClick={() => setMobileToggle(false)}>
      Portfolio
    </NavLink>
  </li>
<li>
        <NavLink to="/Meet-Jaleel" onClick={() => setMobileToggle(false)}>
          Founder & Vision
        </NavLink>
      </li>
  
  {/* Otherpages Dropdown 
  <li className="menu-item-has-children">
    <span>Otherpages</span>
    <ul className="dropdown-menu">
      <li>
        <NavLink to="/marketing-agency" onClick={() => setMobileToggle(false)}>
          Marketing Agency
        </NavLink>
      </li>
      <li>
        <NavLink to="/digital-agency" onClick={() => setMobileToggle(false)}>
          Digital Agency
        </NavLink>
      </li>
      <li>
        <NavLink to="/freelancer-agency" onClick={() => setMobileToggle(false)}>
          Freelancer Agency
        </NavLink>
      </li>
      <li>
        <NavLink to="/architecture-agency" onClick={() => setMobileToggle(false)}>
          Architecture Agency
        </NavLink>
      </li>
      <li>
        <NavLink to="/creative-solution" onClick={() => setMobileToggle(false)}>
          Creative Solution
        </NavLink>
      </li>
      <li>
        <NavLink to="/personal-portfolio" onClick={() => setMobileToggle(false)}>
          Personal Portfolio
        </NavLink>
      </li>
      <li>
        <NavLink to="/showcase-portfolio" onClick={() => setMobileToggle(false)}>
          Showcase Portfolio
        </NavLink>
      </li>
      <li>
        <NavLink to="/case-study-showcase" onClick={() => setMobileToggle(false)}>
          Case Study Showcase
        </NavLink>
      </li>
      <li>
        <NavLink to="/video-showcase" onClick={() => setMobileToggle(false)}>
          Video Showcase
        </NavLink>
      </li>
      <li>
        <NavLink to="/team" onClick={() => setMobileToggle(false)}>
          Team
        </NavLink>
      </li>
      <li>
        <NavLink to="/portfolio" onClick={() => setMobileToggle(false)}>
          Portfolio (Old)
        </NavLink>
      </li>
      <li>
        <NavLink to="/blog" onClick={() => setMobileToggle(false)}>
          Blog
        </NavLink>
      </li>
    </ul>
  </li>
*/}
  {/* Contact and FAQ as standalone buttons */}
  <li>
    <NavLink to="/contact" onClick={() => setMobileToggle(false)}>
      Contact
    </NavLink>
  </li>
  <li>
    <NavLink to="/faq" onClick={() => setMobileToggle(false)}>
      FAQ
    </NavLink>
  </li>
</ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs-munu_toggle cs-toggle_active'
                        : 'cs-munu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </Div>
              </Div>
              <Div className="cs-main_header_right">
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <Div
        className={
          sideHeaderToggle ? 'cs-side_header active' : 'cs-side_header'
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to="/">
            <img src="/images/VOXLOGO.png" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading">
              Do you have a project in your <br /> mind? Let's talk.
            </h2>
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title="Contact Us" withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <Newsletter
              title="Subscribe"
              subtitle="Subscribe for updates on meaningful edits, creator stories, and visual journeys."
              placeholder="example@gmail.com"
            />
          </Div>
          <Div className="cs-side_header_box">
            <SocialWidget />
          </Div>
        </Div>
      </Div>
    </>
  );
}
